<i18n src="../../../locales/lang.json"></i18n>
<template>
  <div class="row p-0 m-0">
    <div class="col-12">
      <i class="icon-move handle" style="margin-top:12px;float:left;"></i>
      <button data-type='image' style="float: left; margin-left: 1px; margin-right: 1px; color: inherit" data-id='0' type='button' class='btn btn-outline btn-icon' @click="clickItem(el)"><i class='icon-attachment'></i></button>
      <input @change="onChange($event)" class="form-control form-control-lg p-1 col-8 col-md-8" type="text" v-model="el.Text" style="float: left;" />
      <element-controls class="element-controls" v-bind:el="el" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings"></element-controls>
    </div>

    <!-- Displays a uploaded file -->
    <div v-if="el.ElementType == 0 && (el.Url != null && el.Url != '') && el.Settings.Property.IncludeInProcedure == 'true'" class="item item-smaller p-0">
      <div class="row p-0 m-0" v-show="el.Settings.Property.IncludeInProcedure == 'true'">
        <img class="item-text" v-bind:src="el.Url" width="100%" />
        <span v-if="el.Settings.Property.imagecaption">{{el.Settings.Property.imagecaption}}</span>
      </div>
    </div>

    <!-- Displays a uploaded file -->
    <div v-if="el.ElementType == 0 && (el.Url != null && el.Url != '') && el.Settings.Property.IncludeInProcedure != 'true'" class="item item-smaller">
      <div v-show="el.hasErrors == true" class="row p-0 m-0">
        <div class="col-12 p-0 text-error">
          {{$t('field_is_required')}}
        </div>
      </div>
      <div class="row" v-show="el.Settings.Property.IncludeInProcedure != 'true'">
        <div class="col-12 p-0 px-1" v-show="el.Url != null && el.Url != ''">
          <!--Identifyable file type-->
          <a target="_blank" @click="clickItem(el)" v-if="getIconImage(el) != null">
            <img v-bind:src="getIconImage(el)" width="28" height="28" style="margin-left:5px;margin-bottom:6px;" />
          </a>
          <!--default link-->
          <a target="_blank" v-if="getIconImage(el) == null" @click="clickItem(el)" style="margin-left: -5px; margin-bottom: 6px; color: inherit; cursor:pointer;"><i class="icon-link"></i></a>
          <a target="_blank" @click="clickItem(el)" style="text-decoration: underline !important; cursor: pointer;">{{el.Text}}</a>
          <button v-show="el.Overridden == true" type="button" class="btn btn-icon" style="font-size:10px; border:0; padding:5px;cursor:pointer;text-decoration:underline;" @click="deleteItem(el)"><i class="icon-cross2" style="font-size:12px;"></i></button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import ProcedureService from "../../services/ProcedureService";
  export default {
    name: "element-image",
    components: {
      ProcedureService
    },
    props: {
      el: {
        type: Object,
        default: null
      },
      overelement: {
        type: Object,
        default: null
      },
    },
    data() {
      return {

      };
    },
    methods: {
      getIconImage(el) {
        return ProcedureService.getIconImage(el);
      },
      getIconFromMimetype(mimetype) {
        return ProcedureService.getIconFromMimetype(mimetype);
      },
      onChange() {
        this.$store.markAsChanged();
      },
      clickSettings(el) {
        this.$emit('clickSettings', el);
      },
      clickItem(el) {
        this.$emit('clickItem', el);
      },
      deleteItem(id) {
        if (id == null || typeof id == "undefined")
          id = this.value.Id;
        this.$emit('deleteItem', id);
      },
      getId() {
        return this._uid;
      },
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
  };

</script>

<style scoped>

  /*Make the controls a little more quite*/

  .icon-move, .item .element-controls, .item btn-icon, .item .btn-icon i {
    color: #ddd;
  }

  .item .form-control {
    border-color: transparent;
  }

  .item:focus-within .form-control, .form-control:active, .form-control:focus {
    border-color: #2196f3;
  }

  .item:focus-within .element-controls, .item:hover .element-controls,
  .item:hover .icon-move,
  .item:focus-within .icon-move,
  .item:hover .btn-icon i, .item:focus-within .btn-icon i {
    color: black;
  }

  .item:active .custom-control-label::before, .item:focus-within .custom-control-label::before, .item:hover .custom-control-label::before {
    border-color: black;
  }

  /*End Make the controls a little more quite*/

  .handle {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/procedure/procedure-editor-elements/element-image.vue